import LegalLayout from "./Legallayout";
import { PRIVACY_POLICY } from "./Legaldata";

export default function PrivacyPolicy() {
  return <LegalLayout doc={PRIVACY_POLICY} />;
}